import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Monate } from '@core/model/monate';
import { setError, unsetError } from '../utils/form-utils';

export class DateValidator {
    public static frueherAls(stichtag: Date): ValidatorFn {
        return (inputControl: AbstractControl): ValidationErrors | null => {
            const value: Date = inputControl.value;
            if (!value || !stichtag) {
                return null;
            }
            if (value > stichtag) {
                return { invalidDate: true };
            }
            return null;
        };
    }

    public static spaeterAls(date: Date): ValidatorFn {
        return (inputControl: AbstractControl): ValidationErrors | null => {
            const inputDate: Date = inputControl.value;
            if (!date || !inputDate) {
                return null;
            }
            if (date > inputDate) {
                return { invalidDate: true };
            }
            return null;
        };
    }

    /*  Validiert zwei Datumsfelder.
        Ist das dateVonFormField größer als dateBisFormField, dann wird das Formular ungültig mit Error invalidRange: true
        und auf bis Eingabefeld wird 'invalidRange' Errors gesetzt.
     */
    public static vonDateVorBisDate(dateVonFormField: string, dateBisFormField: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const dateVonFormValue = control.get(dateVonFormField)?.value;
            const dateBisFormValue = control.get(dateBisFormField)?.value;

            if (dateVonFormValue && dateBisFormValue) {
                const vonDatum = new Date(dateVonFormValue);
                const bisDatum = new Date(dateBisFormValue);

                if (vonDatum > bisDatum) {
                    return setError(control.get(dateBisFormField), 'invalidRange');
                }
            }

            return unsetError(control.get(dateBisFormField), 'invalidRange');
        };
    }

    /*  Validiert ein Datumsfeld.
       Liegt das inputControl Datum Feld nicht innerhalb der zwei Daten vonDatum und bisDatum, dann wird das Formular
       ungültig mit Error invalidRange: true und auf bis Eingabefeld wird 'invalidRange' Errors gesetzt.
    */
    public static dateZwischenVonDateUndBisDate(vonDatum: Date, bisDatum: Date): ValidatorFn {
        return (inputControl: AbstractControl): ValidationErrors | null => {
            const eingabeDate: Date = inputControl.value;
            if (!vonDatum || !bisDatum || !eingabeDate) {
                return null;
            }
            if (vonDatum > eingabeDate || eingabeDate > bisDatum) {
                return { invalidDate: true };
            }
            return null;
        };
    }

    /*  Validiert den Tag eines Datumsfeld auf FirstOfMonth
        Ist das inputControl Datum Feld nicht der 1.Tag des Monats, wird das Formular ungültig mit Error invalidDateFirstDayMonth: true gesetzt.
   */
    public static firstOfMonth(): ValidatorFn {
        return (inputControl: AbstractControl): ValidationErrors | null => {
            const inputDate: Date = inputControl.value;
            if (!inputDate) {
                return null;
            }
            if (inputDate.getDate() !== 1) {
                return { invalidDateFirstDayMonth: true };
            }
            return null;
        };
    }

    /*  Validiert den Tag eines Datumsfeld auf LastOfMonth
    Ist das inputControl Datum Feld nicht der 1.Tag des Monats, wird das Formular ungültig mit Error invalidDateFirstDayMonth: true gesetzt.
*/
    public static lastOfMonth(): ValidatorFn {
        return (inputControl: AbstractControl): ValidationErrors | null => {
            const inputDate: Date = inputControl.value;
            if (!inputDate) {
                return null;
            }
            if (this.getLastDayOfMonth(inputDate) !== inputDate.getDate()) {
                return { invalidDateLastDayMonth: true };
            }
            return null;
        };
    }

    private static getLastDayOfMonth(date: Date): number {
        return new Date(date.getFullYear(), date.getMonth(), 0).getDate();
    }

    public static imSelbenKalenderjahr(dateVonFormField: string, dateBisFormField: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const dateVonFormValue = control.get(dateVonFormField)?.value;
            const dateBisFormValue = control.get(dateBisFormField)?.value;

            if (dateVonFormValue && dateBisFormValue) {
                const vonDatum = new Date(dateVonFormValue);
                const bisDatum = new Date(dateBisFormValue);

                if (vonDatum.getFullYear() !== bisDatum.getFullYear()) {
                    return setError(control.get(dateBisFormField), 'invalidYear');
                }
            }

            return unsetError(control.get(dateBisFormField), 'invalidYear');
        };
    }

    public static isDateValid(dayField: string, monthField: string, yearField: string): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const day = Number(group.get(dayField)?.value);
            const monthLabel = group.get(monthField)?.value;
            const year = Number(group.get(yearField)?.value);

            const monthEntry = Monate.filter((i) => i.value === monthLabel)[0];
            if (!monthEntry) {
                return { invalidMonth: true };
            }
            const now = new Date().setHours(0, 0, 0, 0);
            const month = monthEntry.value;
            const date = new Date(year, month - 1, day);

            var today = new Date();
            var birthdate = date;

            var age = today.getFullYear() - birthdate.getFullYear();

            if (today.getMonth() < birthdate.getMonth()
                || (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate())) {
                age--;
            }

            const ageCheck = age >= 18 && age <= 80;

            const isValid = date.getFullYear() === year
                && date.getMonth() === month - 1
                && date.getDate() === day
                && date.setHours(0,0,0,0) < now
                && ageCheck;

            return isValid ? null : { invalidDate: true };
        };
    }
}
